<template>
      <sui-accordion exclusive>
        <div v-for="menu in menus" :key="menu.id" class="mb-20">
            <sui-accordion-title active>
                <h4 class="ui blue header">
                    <sui-icon name="dropdown" /> {{menu.name}} ({{getSelectedMenus(menu)}}/{{menu.childs.length || 0}})
                </h4>
            </sui-accordion-title>
            <sui-accordion-content active>
                <sui-list>
                    <a is="sui-list-item" v-for="child in menu.childs" :key="child.id">
                        <sui-checkbox :label="child.name" v-model="child.selected" :disabled="!child.activo"/>
                        <span class="deprecated" v-if="!child.activo"> (depreciado)</span>
                    </a>
                </sui-list>
            </sui-accordion-content>
        </div>
    </sui-accordion>
</template>

<script>
import MenuService from '@/services/MenuService'
import Utils from '@/common/Utils'

export default {
    name: 'Menus',
    props: ['user'],
    data () {
        return {
            menus: [],
            loader: undefined
        }
    },
    async beforeMount () {
        this.loader = this.$loading.show()
        this.getMenus()
    },
    methods: {
        async getMenus () {
            try {
                let { data } = await MenuService.getAll({})
                this.menus = Utils.getMenu(data)
                this.setMenus(data)
                this.loader.hide()
            } catch (error) {
                console.error(error)
                this.$swal({
                    title: error.message,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Volver al listado',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                })
            }
        },
        setMenus () {
            for (let menu of this.menus) {
                if (this.user.menus.includes(menu.id)) {
                    menu.selected = true
                    menu.childs.filter(m => this.user.menus.includes(m.id)).map(m => {
                        m.selected = true
                        return m
                    })
                }
            }
        },

        getSelectedMenus (menu) {
            return menu.childs.filter(m => m.selected).length || 0
        }
    },
    watch: {
        menusToSave () {
            this.$emit('setMenus', this.menusToSave)
        }
    },
    computed: {
        menusToSave () {
            let menus = []
            for (let menu of this.menus) {
                // Se filtran los activos por si habilitan en el inspector
                let childs = menu.childs.filter(m => m.selected === true && m.activo === true).map(m => { return m.id })
                if (childs.length > 0) {
                    menus.push(menu.id)
                    menus = menus.concat(childs)
                }
            }
            return menus
        }
    }
}
</script>

<style scoped>
    .deprecated {
        color: gray;
        font-weight: bold;
        font-style: italic;
    }
</style>
